import { render, staticRenderFns } from "./RedirectAuth.vue?vue&type=template&id=560d72f6&scoped=true&"
import script from "./RedirectAuth.vue?vue&type=script&lang=js&"
export * from "./RedirectAuth.vue?vue&type=script&lang=js&"
import style0 from "./RedirectAuth.vue?vue&type=style&index=0&id=560d72f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d72f6",
  null
  
)

component.options.__file = "RedirectAuth.vue"
export default component.exports